import React from 'react';
import styled from 'styled-components';
import { FormattedText } from '@estee/elc-formatters';
import { containsHTML } from '../../utils/DomUtils';
import { IComponentNotificationProps } from './ComponentNotificationFactory';

const ItemList = styled.ul`
  margin-left: 23px;
`;
 
const Item = styled.li``;

const ShippingRestrictionsAPO: React.FunctionComponent<IComponentNotificationProps>  =
  ({
    notification,
  }: IComponentNotificationProps) => {

    let htmlContent;

    if (containsHTML(notification.text)) {
      const productListHtml = notification.products?.reduce((prev, current) => `${prev}<li>${current}</li>`, '');
      const styledList = `<ul class="rc-notification-removed-list" style=padding:revert;">${productListHtml}</ul>`;
      htmlContent = notification.text.replace('::products::', styledList);
    }

    const itemRenderer = (items: string): React.ReactNode => items?.split(',')?.map((item, index) => (
    <Item key={index}>
      {item}
    </Item>
    ));

    return htmlContent ? <span dangerouslySetInnerHTML={{ __html: htmlContent }} /> : (
    <FormattedText
        text={notification.text}
        values={{ products: notification.products?.join(',') ?? '' }}
        valueRender={({ value }) => (
          <ItemList className='rc-notification-removed-list'>
            {itemRenderer(value as string)}
          </ItemList>
        )}
    />
    );
  };

export default ShippingRestrictionsAPO;
